// Truncate a string
export default function(str, length, suffix = "...") {
  if (str.length > length) {
    return str.substring(0, length) + suffix;
  }
  
  return str;
}